(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["portrait-configurator"] && !Shopify.designMode) return;
  try {
    
function initPortraits(scope){
  scope.querySelectorAll('[data-portrait-config]').forEach(root=>{
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    const variants=JSON.parse(root.querySelector('[data-variants]').textContent);
    const form=root.querySelector('form');
    const process=root.querySelector('[data-process]');
    const agreements=root.querySelector('[data-agreements]');
    let processOpened=false;
    const readNotice=root.querySelector('[data-read-notice]');
    const agreementLock=root.querySelector('[data-agreement-lock]');
    agreementLock.addEventListener('click',event=>{
      if(processOpened)return;
      readNotice.hidden=false;
      const anchor=agreementLock.getBoundingClientRect();
      const x=event.detail?event.clientX:anchor.left+20;
      const y=event.detail?event.clientY:anchor.top+20;
      const bounds=readNotice.getBoundingClientRect();
      readNotice.style.left=Math.max(12,Math.min(x+12,window.innerWidth-bounds.width-12))+'px';
      readNotice.style.top=Math.max(12,Math.min(y+12,window.innerHeight-bounds.height-12))+'px';
    });
    document.addEventListener('click',event=>{
      if(!agreementLock.contains(event.target))readNotice.hidden=true;
    });
    document.addEventListener('keydown',event=>{
      if(event.key==='Escape')readNotice.hidden=true;
    });
    window.addEventListener('scroll',()=>readNotice.hidden=true,{passive:true});
    const examples=Array.from(root.querySelectorAll('[data-example]'));
    const buttons=Array.from(root.querySelectorAll('[data-example-button]'));
    const rules=JSON.parse(root.querySelector('[data-example-rules]').textContent);
    const showExample=index=>{
      examples.forEach((example,i)=>example.hidden=i!==index);
      buttons.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));
    };
    buttons.forEach(button=>button.addEventListener('click',()=>showExample(Number(button.dataset.exampleButton))));
    const photos=Array.from(root.querySelectorAll('[data-photo]'));
    const error=root.querySelector('[data-photo-error]');
    const validatePhotos=()=>{
      const selected=photos.some(input=>input.files.length>0&&!input.validationMessage);
      photos[0].required=!root.querySelector('[data-later]').checked&&!selected;
    };
    photos.forEach(input=>{
      const row=input.closest('[data-photo-row]');
      const thumbnail=row.querySelector('[data-photo-preview]');
      const remove=row.querySelector('[data-remove-photo]');
      const clearPreview=()=>{
        if(thumbnail.dataset.objectUrl)URL.revokeObjectURL(thumbnail.dataset.objectUrl);
        delete thumbnail.dataset.objectUrl;
        thumbnail.removeAttribute('src');
        thumbnail.hidden=true;
        remove.hidden=true;
      };
      input.addEventListener('change',()=>{
        clearPreview();
        input.setCustomValidity('');
        error.textContent='';
        const file=input.files[0];
        if(file){
          if(!['image/jpeg','image/png','image/webp'].includes(file.type))input.setCustomValidity(error.dataset.typeError);
          else if(file.size>10*1024*1024)input.setCustomValidity(error.dataset.sizeError);
          if(input.validationMessage){error.textContent=input.validationMessage;input.reportValidity();}
          else{
            thumbnail.dataset.objectUrl=URL.createObjectURL(file);
            thumbnail.src=thumbnail.dataset.objectUrl;
            thumbnail.hidden=false;
          }
          remove.hidden=false;
        }
        validatePhotos();
      });
      remove.addEventListener('click',()=>{
        input.value='';
        input.setCustomValidity('');
        clearPreview();
        error.textContent='';
        validatePhotos();
      });
    });
    root.querySelector('[data-later]').addEventListener('change',validatePhotos);
    root.querySelector('[data-more-photos]').addEventListener('click',event=>{
      const row=root.querySelector('[data-photo-row][hidden]');
      if(row)row.hidden=false;
      event.currentTarget.hidden=!root.querySelector('[data-photo-row][hidden]');
    });
    let lastExampleKey='';
    const update=()=>{
      const petPortrait=root.dataset.petPortrait==='true';
      const people=petPortrait?0:Number(root.querySelector('[data-people]').value);
      const pets=Number(root.querySelector('[data-pets]').value);
      const objects=petPortrait?0:Number(root.querySelector('[data-objects]').value);
      const background=!petPortrait&&root.querySelector('[data-background]').value==='Yes';
      const price=petPortrait?9500+(pets-1)*3000:14500+(people-1)*4500+(pets+objects)*3000+(background?7500:0);
      const variant=variants.find(v=>v.price===price);
      root.querySelector('[data-total]').textContent=new Intl.NumberFormat(root.dataset.locale,{style:'currency',currency:root.dataset.currency}).format(price/100);
      root.querySelector('[data-variant]').value=variant?variant.id:'';
      root.querySelector('[data-submit]').disabled=!processOpened||!variant||!variant.available||!Array.from(root.querySelectorAll('[data-agreement]')).every(input=>input.checked);
      const exampleKey=people+'-'+pets;
      if(exampleKey!==lastExampleKey){
        lastExampleKey=exampleKey;
        let bestIndex=0;
        let bestScore=Infinity;
        rules.forEach((rule,index)=>{
          const score=Math.abs(rule.people-people)*10+Math.abs(rule.pets-pets);
          if(score<bestScore){bestScore=score;bestIndex=index;}
        });
        showExample(bestIndex);
      }
    };
    process.addEventListener('toggle',()=>{
      if(process.open){
        processOpened=true;
        agreements.disabled=false;
        readNotice.hidden=true;
        agreementLock.hidden=true;
        agreements.removeAttribute('aria-describedby');
        update();
      }
    });
    form.addEventListener('change',update);
    update();
    validatePhotos();
  });
}
initPortraits(document);
document.addEventListener('shopify:section:load',event=>initPortraits(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nelly-review-form')) {
    customElements.define('nelly-review-form', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const frame = this.querySelector('iframe');
        const details = this.querySelector('details');
        if (!frame || !details) return;
        const target = new URL(frame.dataset.src, window.location.href);
        if (target.protocol !== 'https:') return;
        const load = () => {
          if (details.open && !frame.hasAttribute('src')) frame.src = target.href;
        };
        details.addEventListener('toggle', load, { signal: this.abort.signal });
        window.addEventListener('message', event => {
          if (event.source !== frame.contentWindow || event.origin !== target.origin) return;
          if (event.data?.type !== 'nelly-review-height' || !Number.isFinite(event.data.height)) return;
          frame.style.height = Math.min(5000, Math.max(120, event.data.height + 12)) + 'px';
        }, { signal: this.abort.signal });
        load();
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
